module.exports = __webpack_public_path__ + "static/img/24.5537cd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/24.jpg
// module id = pyZp
// module chunks = 1